import React from 'react';
import { Card } from './ui/card';

const WhatIveBuilt = () => {
  const systems = [
    {
      title: 'AI-Powered SDR & Lead Qualification Workflows',
      description: 'Automated qualification, scoring, and nurture sequences that reduce manual work by 70% while improving conversion rates.',
    },
    {
      title: 'Lean Marketing Teams with High Output',
      description: 'Built teams of 5-10 people operating like teams of 30—using AI tools, smart workflows, and clear priorities.',
    },
    {
      title: 'Scalable Content & Social Systems Using AI',
      description: 'Content engines that produce quality at volume—repurposing, distribution, and engagement automated where it makes sense.',
    },
    {
      title: 'Performance Marketing Structures Built for Efficiency',
      description: 'Managed ₹35-40Cr annual budgets focused on CAC optimization, not spend inflation. Drove ₹110Cr+ in measurable impact.',
    },
    {
      title: 'Marketing Operating Models That Scale Without Headcount Bloat',
      description: 'Designed systems, processes, and dashboards that let teams execute autonomously—no micromanagement required.',
    },
    {
      title: 'GTM Playbooks for B2B & Enterprise',
      description: 'Launched products and entered new markets with clear positioning, segmented messaging, and conversion-focused execution.',
    },
  ];

  return (
    <section id="work" className="py-24 px-4 sm:px-6 lg:px-8 bg-slate-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-4">What I've Built</h2>
        <p className="text-slate-600 mb-12 max-w-3xl">
          I focus on systems, not tasks. Here's what that looks like in practice.
        </p>

        <div className="space-y-4">
          {systems.map((system, index) => (
            <Card key={index} className="p-6 border-slate-200 hover:border-slate-300 transition-colors">
              <h3 className="text-lg font-semibold text-slate-900 mb-2">{system.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{system.description}</p>
            </Card>
          ))}
        </div>

        <div className="mt-12 p-8 bg-slate-900 text-white rounded-lg">
          <p className="text-lg">
            <strong>The common thread?</strong> I build repeatable engines, not one-off campaigns. Marketing that 
            compounds over time, not marketing that burns out.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatIveBuilt;